<template>
    <inertia-head>
        <title>{{ title }}</title>
        <meta property="og:image" :content="`${$page.props.baseUrl}/assets/frontend/hero.jpg`" />
    </inertia-head>

    <breadcrumb>
        <breadcrumb-item>
            <inertia-link href="/">Hem</inertia-link>
        </breadcrumb-item>
        <breadcrumb-item :last="initialCategory ? false : true">
            <inertia-link v-if="initialCategory" :href="`/${city.slug}`">{{ city.name }}</inertia-link>
            <span v-if="!initialCategory">{{ city.name }}</span>
        </breadcrumb-item>
        <breadcrumb-item v-if="initialCategory" :last="initialSubcategory ? false : true">
            <span v-if="!initialSubcategory">{{ initialCategory.name }}</span>
            <inertia-link v-if="initialSubcategory" :href="`/${city.slug}/${initialCategory.slug}`">{{ initialCategory.name }}</inertia-link>
        </breadcrumb-item>
        <breadcrumb-item v-if="initialSubcategory" :last="true">
            {{ initialSubcategory.name }}
        </breadcrumb-item>
    </breadcrumb>

    <main class="main city-page page-content-padding" v-if="city">
        <div class="container">
            <h1 class="page-heading">Lokal topplista {{ city.name }}</h1>

            <p class="text-dark px-2 mx-auto" style="max-width: 800px; margin-top: 25px;">
                Shoppa lokalt och stöd dina lokala företag! Här hittar du Lokala rabatter och erbjudanden i {{ city.name }}. Är det något företag du saknar? Skriv till oss på <inertia-link href="/kontakta-oss">Kontakta oss</inertia-link>, så ska vi göra vårt bästa för att ändra på det :) För här ska du hitta rabattkoder till allt din familj behöver!
            </p>

            <Popper style="display: inline-block;">
                <div class="mb-4" style="display: inline-flex; justify-content: center; align-items: center; margin-top: 10px; cursor: pointer;">
                    <span>Byt stad</span>
                    <svg xmlns="http://www.w3.org/2000/svg" style="width: 20px; height: 20px; margin-left: 5px;" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                    </svg>
                </div>

                <template #content>
                    <div style="max-height: 200px; overflow: scroll; overflow-x: hidden;">
                        <ul>
                            <li v-for="listCity in cities" style="padding: 2px;" :class="{ 'city-selected': (city.id === listCity.id) }">
                                <inertia-link :href="`/${listCity.slug}`">{{ listCity.name }}</inertia-link>
                            </li>
                        </ul>
                    </div>
                </template>
            </Popper>
        </div>

        <div class="container px-4 pb-4">
            <div class="list-result px-1 py-1 container">
                <div id="new-campaigns-scroll" class="swiper-container-with-pagination" v-if="mostPopularCampaigns.length > 0">
                    <swiper-slider :breakpoints="{
                        0: { slidesPerView: 2, spaceBetween: 10 },
                        768: { slidesPerView: 4, spaceBetween: 20 },
                        1024: { slidesPerView: 4, spaceBetween:20 },
                    }">
                        <swiper-slide v-for="popularCampaign in mostPopularCampaigns">
                            <campaign-item :key="popularCampaign.slug" :campaign="popularCampaign" />
                        </swiper-slide>
                    </swiper-slider>
                </div>
            </div>
        </div>

        <div class="container-fluid" style="padding: 0; margin-top: 25px;">
            <div class="categories-circles">
                <div class="container categories" style="width: 80%;margin: 0 auto;padding: 2rem 0rem;text-align: center;background-color: #fff;">
                    <div class="categories-circles-items-container">
                        <div class="item"  id="category-item" v-for="category in categories.filter(c => c.parent_id === null)" :key="category.id" style="display: inline-block;width: auto;text-align: center;margin: 0 5px;">
                            <inertia-link :href="`/${city.slug}/${category.slug}`">
                                <icon :name="category.slug"></icon><br>
                                <span class="icons-start">
                                    {{ category.name.replace(/ .*/, '').replace(',', '') }} </span>
                            </inertia-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="container p-4">
            <h2 v-if="!initialCategory" style="text-transform: none;font-size: 25px;">
                Alla rabatter i
                {{ city.name }}
            </h2>

            <h2 v-if="initialCategory" style="text-transform: none;">
                {{ initialCategory.name }} i
                {{ city.name }}
            </h2>

            <select class="mt-2 badge badge-secondary" @change="categoryChanged">
                <option value="null">Välj kategori</option>
                <option
                    v-for="category in categories.filter(c => c.parent_id === null)"
                    :selected="(initialCategory && initialCategory.slug === category.slug)"
                    :value="category.slug">
                    {{ category.name }}
                </option>
            </select>

            <select v-if="initialCategory?.childrens" class="mt-2 badge badge-secondary ms-2" style="width: 170px;" @change="subcategoryChanged">
                <option value="null">Alla underkategorier</option>
                <option
                    v-for="subcategory in initialCategory.childrens"
                    :selected="(initialSubcategory && initialSubcategory.slug === subcategory.slug)"
                    :value="subcategory.slug">
                    {{ subcategory.name }}
                </option>
            </select>

            <select v-else class="mt-2 badge badge-secondary ms-2" style="width: 170px;" disabled="">
                <option>Välj underkategori</option>
            </select>

            <div class="list-result container px-1 py-1 mt-4">
                <div class="row gx-3">
                    <div class="col-6 col-md-3 mb-4" v-for="campaign in campaigns" :key="campaign.slug">
                        <campaign-item :campaign="campaign" />
                    </div>
                    <infinite-loading @in-view="infiniteHandler">
                        <template #loading>
                            Laddar...
                        </template>
                    </infinite-loading>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
    import Popper from 'vue3-popper';
    import { SwiperSlide } from 'swiper/vue';
    import SwiperSlider from '@/components/Swiper';
    import { router } from '@inertiajs/vue3';
    import { getFallbackImage } from '@/Util/images';

    export default {
        props: {
            initialCity: Object,
            initialCategory: Object|null,
            initialSubcategory: Object|null,
            data: Array,
            paginator: Object,
        },

        components: { SwiperSlider, SwiperSlide, Popper },

        data () {
            return {
                campaigns: this.data,
                campaignsPaginator: this.paginator,
                mostPopularCampaigns: [],
            }
        },

        created () {
            this.getMostPopularCampaigns();
        },

        computed: {
            title () {
                var title = ``;

                if (this.initialCategory) {
                    title += this.initialCategory.name;
                }

                return `Rabattkoder ${title} ${this.initialCity.name}`;
            },
            cities () {
                return this.$page.props.cities;
            },
            categories () {
                return this.$page.props.categories;
            },
            city () {
                return this.cities.find(c => c.slug === this.initialCity.slug);
            }
        },

        methods: {
            categoryChanged (e) {
                const slug = e.target.value;

                if (slug !== 'null') {
                    router.visit(`/${this.city.slug}/${slug}`);
                } else {
                    router.visit(`/${this.city.slug}`);
                }
            },

            subcategoryChanged (e) {
                if (! this.initialCategory) {
                    return;
                }

                const slug = e.target.value;

                if (slug !== 'null') {
                    router.visit(`/${this.city.slug}/${this.initialCategory.slug}/${slug}`);
                } else {
                    router.visit(`/${this.city.slug}/${this.initialCategory.slug}`);
                }
            },

            infiniteHandler($state) {
                if (!this.campaignsPaginator.next_page_url) {
                    $state.complete();
                    return;
                }

                this.getCampaigns().then(response => {
                    this.campaigns = this.campaigns.concat(response.data.data);
                    this.campaignsPaginator = response.data.paginator;

                    if (this.campaignsPaginator.current_page === this.campaignsPaginator.last_page) {
                        $state.complete();
                    } else {
                        $state.loaded();
                    }
                });
            },

            async getMostPopularCampaigns () {
                await axios.get(`/api/city/${this.city.slug}/mostPopularCampaigns`).then(response => {
                    this.mostPopularCampaigns = response.data.map((r) => {
                        r.fallback = getFallbackImage();
                        return r;
                    });
                });
            },

            getCampaigns () {
                let url = `${this.campaignsPaginator.next_page_url}`;
                return axios.get(url);
            }
        }
    }
</script>
